import { render, staticRenderFns } from "./ContestDetail.vue?vue&type=template&id=dc71f2fe&scoped=true"
import script from "./ContestDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc71f2fe",
  null
  
)

export default component.exports